<ng-template #actionsPopup>
  <p class="popup-text"
     (click)="getUserDetails();userDetail.show()">User details
  </p>
  <app-modal #userDetail
             ownerUname="{{ownerUname}}"
             ownerFname="{{ownerFname}}"
             ownerLname="{{ownerLname}}"
             ownerEmail="{{ownerEmail}}"
             ownerAffiliation="{{ownerAffiliation}}"></app-modal>

  <!--Impersonate popup option-->
  <!--<p class="popup-text">Impersonate</p>-->

</ng-template>

<div class="owner-edit-row">
  <button class="server-name-btn"
          [popover]="actionsPopup"
          placement="right"
          triggers="click"
          [outsideClick]="true"
          container="body"
          #buttonCheck
          value="{{inputValue}}"
          [hidden]="buttonIsHidden"
          [disabled]="!hasOwner">{{inputValue}}
  </button>

  <div class="modify-live-search"
       *ngIf="allOwner.length > 0 && !searchIsHidden">
    <ngx-select [allowClear]="true"
                [items]="allOwner"
                #select1
                (open)="closeOtherSelects(select1)"
                [(ngModel)]="initialValue"
                (select)="selectedOwner($event)"
                (remove)="removed($event)">
    </ngx-select>
  </div>

  <div class="select-edit-btn-area">
    <i *ngIf="isAdmin"
       class="fa fa-edit transition text-tooltip"
       aria-hidden="true"
       title-popup="Edit"
       (click)="buttonOnClick()"
       [hidden]="buttonIsHidden"></i>
    <button class=" transition text-tooltip tooltip-edit"
            [hidden]="!buttonIsHidden"
            (click)="buttonOnSave()"
            [disabled]="!isChanged"
            title-popup="Save">
      <i class="fa fa-check"
         [ngClass]="{'disabled':!isChanged}"
         aria-hidden="true"></i>
    </button>
    <button class="transition text-tooltip tooltip-edit"
            title-popup="Cancel"
            [hidden]="!buttonIsHidden"
            (click)="buttonOnCancel(buttonCheck)">
      <i class="fa fa-times"
         aria-hidden="true"></i>
    </button>
  </div>
</div>
<div class="alert alert-danger alert-validate error-validate"
     *ngIf="hasError">{{errorMessage}}
</div>
